"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleToPatchFlightStatusRequest = exports.handleToPostFlightStatusRequest = undefined;

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _effects = require("redux-saga/effects");

var _utilityFunctions = require("../utils/utilityFunctions");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _apiHelper = require("../api/api-helper");

var _updateResources = require("./updateResources");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(validateTransferAirport),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(validateAgainstMultipleTransferServices),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(validateSegment);

var DEFAULT_SEGMENT_ERROR_CODE = "INVALID_FLIGHT_SEGMENT";
var SEGMENT_NO_SCHEDULE_MATCH = "FLIGHT_SEGMENT_NO_SCHEDULE_MATCH";
var ZERO_SCHEDULES_RETURNED = "FLIGHT_SEGMENT_ZERO_SCHEDULES_RETURNED";

/**
 * Checks the transport data against the flight segment.
 * If the passenger is on the transfer then fetch the transport,
 * Compare airport codes, and return an error if they do not match.
 * */
function validateTransferAirport(transfer, paths, dataForAirportCheck) {
    var authToken, locale, segmentResponse, transportData, currentTransportData, productId, transportResponse, airportCodeOnTransfer, airportCodeOnSegment;
    return _regenerator2.default.wrap(function validateTransferAirport$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    // Too long to type in JsDoc but `requiredData` is the data required for the validation to happen.
                    authToken = dataForAirportCheck.authToken, locale = dataForAirportCheck.locale, segmentResponse = dataForAirportCheck.segmentResponse, transportData = dataForAirportCheck.transportData;
                    currentTransportData = transportData;

                    if (currentTransportData) {
                        _context.next = 12;
                        break;
                    }

                    // If transport data is not provided then request the data.
                    productId = _lodash2.default.get(transfer, "product.id");

                    if (productId) {
                        _context.next = 6;
                        break;
                    }

                    return _context.abrupt("return", null);

                case 6:
                    _context.next = 8;
                    return (0, _effects.call)(_apiHelper.getTransportData, productId, authToken, locale);

                case 8:
                    transportResponse = _context.sent;

                    if (!(transportResponse && transportResponse.error)) {
                        _context.next = 11;
                        break;
                    }

                    return _context.abrupt("return", transportResponse);

                case 11:

                    currentTransportData = transportResponse.transportData;

                case 12:
                    airportCodeOnTransfer = _lodash2.default.get(currentTransportData, paths.addressPath, null);
                    airportCodeOnSegment = _lodash2.default.get(segmentResponse.postSucceededResource, paths.segmentPath, null);

                    // If the transfer airport and segment airport do not match then return with the flightSegmentErrorCode.

                    if (!(airportCodeOnTransfer && airportCodeOnSegment && airportCodeOnTransfer !== airportCodeOnSegment)) {
                        _context.next = 16;
                        break;
                    }

                    return _context.abrupt("return", (0, _extends3.default)({}, segmentResponse, { flightSegmentErrorCode: DEFAULT_SEGMENT_ERROR_CODE }));

                case 16:
                    return _context.abrupt("return", null);

                case 17:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}

// Reminder: The reason this exists is that transfer services are current not categorized on GAPI.
function validateAgainstMultipleTransferServices(isDepartingFromTour, departureServiceId, transfers, dataForAirportCheck) {
    var passengerId, authToken, locale, i, transferServiceResponse, transferServiceData, isAssociated, productId, transportResponse, transportData, _getTransportDirectio, isArrival, isDeparture, addressPath, segmentPath, airportCheck;

    return _regenerator2.default.wrap(function validateAgainstMultipleTransferServices$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.select)(function (state) {
                        return state.user.flightCheckPassengerId;
                    });

                case 2:
                    passengerId = _context2.sent;
                    authToken = dataForAirportCheck.authToken, locale = dataForAirportCheck.locale;
                    i = 0;

                case 5:
                    if (!(i < transfers.length)) {
                        _context2.next = 55;
                        break;
                    }

                    if (!(!transfers[i] || !Array.isArray(transfers[i].customers))) {
                        _context2.next = 8;
                        break;
                    }

                    return _context2.abrupt("continue", 52);

                case 8:
                    if ((0, _utilityFunctions.hasPassenger)(transfers[i].customers, passengerId)) {
                        _context2.next = 10;
                        break;
                    }

                    return _context2.abrupt("continue", 52);

                case 10:
                    _context2.next = 12;
                    return (0, _effects.call)(_apiHelper.getTransferServiceData, transfers[i].id, authToken, locale);

                case 12:
                    transferServiceResponse = _context2.sent;

                    if (!(transferServiceResponse && transferServiceResponse.error)) {
                        _context2.next = 15;
                        break;
                    }

                    return _context2.abrupt("return", transferServiceResponse);

                case 15:
                    transferServiceData = transferServiceResponse.transferServiceData;

                    if (!(!transferServiceData || !transferServiceData.associated_services)) {
                        _context2.next = 18;
                        break;
                    }

                    return _context2.abrupt("continue", 52);

                case 18:

                    // If the departure service ID for the segment does not match that associated to the transfer service then skip.
                    isAssociated = transferServiceData.associated_services.some(function (service) {
                        return service.id === departureServiceId;
                    });

                    if (isAssociated) {
                        _context2.next = 21;
                        break;
                    }

                    return _context2.abrupt("continue", 52);

                case 21:

                    // If there is no product ID then skip otherwise use it to get the transport data.
                    productId = _lodash2.default.get(transferServiceData, "product.id");

                    if (productId) {
                        _context2.next = 24;
                        break;
                    }

                    return _context2.abrupt("continue", 52);

                case 24:
                    _context2.next = 26;
                    return (0, _effects.call)(_apiHelper.getTransportData, productId, authToken, locale);

                case 26:
                    transportResponse = _context2.sent;

                    if (!(transportResponse && transportResponse.error)) {
                        _context2.next = 29;
                        break;
                    }

                    return _context2.abrupt("return", transportResponse);

                case 29:
                    transportData = transportResponse.transportData;

                    if (transportData) {
                        _context2.next = 32;
                        break;
                    }

                    return _context2.abrupt("continue", 52);

                case 32:

                    // Get the sub_type and normalize it.
                    // If there is no transfer direction (Arrival or Departure) then skip since then it's not an airport transfer.
                    _getTransportDirectio = (0, _utilityFunctions.getTransportDirection)(transportData), isArrival = _getTransportDirectio.isArrival, isDeparture = _getTransportDirectio.isDeparture;

                    if (!(!isArrival && !isDeparture)) {
                        _context2.next = 35;
                        break;
                    }

                    return _context2.abrupt("continue", 52);

                case 35:
                    addressPath = void 0;
                    segmentPath = void 0;

                    if (!isDepartingFromTour) {
                        _context2.next = 44;
                        break;
                    }

                    if (isDeparture) {
                        _context2.next = 40;
                        break;
                    }

                    return _context2.abrupt("continue", 52);

                case 40:

                    addressPath = "finish_address.airport.iata_code";
                    segmentPath = "departure_airport.code";
                    _context2.next = 48;
                    break;

                case 44:
                    if (isArrival) {
                        _context2.next = 46;
                        break;
                    }

                    return _context2.abrupt("continue", 52);

                case 46:

                    addressPath = "start_address.airport.iata_code";
                    segmentPath = "arrival_airport.code";

                case 48:
                    _context2.next = 50;
                    return (0, _effects.call)(validateTransferAirport, transferServiceData, {
                        addressPath: addressPath,
                        segmentPath: segmentPath
                    }, (0, _extends3.default)({}, dataForAirportCheck, { transportData: transportData }));

                case 50:
                    airportCheck = _context2.sent;
                    return _context2.abrupt("return", airportCheck || null);

                case 52:
                    i++;
                    _context2.next = 5;
                    break;

                case 55:
                    return _context2.abrupt("return", null);

                case 56:
                case "end":
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Check each flight segment first. If one fails, stop and return the error. If all pass, run the main request.
 *
 * @param {string} departureServiceAction Determine whether its arriving or departing from tour.
 * @param {string} departureServiceId The associated departure service ID.
 * @param {Array} segments Flight segments to check.
 * @param {string} authToken Token for API calls.
 * @param {Function} mainFn Function to run after checks pass.
 * @param {...any} mainArgs Values passed into the main function.
 * @returns {any} Error or main request result.
 */
function validateSegment(departureServiceAction, departureServiceId, segments, authToken, mainFn) {
    for (var _len = arguments.length, mainArgs = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
        mainArgs[_key - 5] = arguments[_key];
    }

    var isDepartingFromTour, locale, i, isZeroScheduleFlow, segmentResponse, _ret, dataForAirportCheck, transferServiceData, airportCheck, arrivalCheckError, departureCheckError;

    return _regenerator2.default.wrap(function validateSegment$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    isDepartingFromTour = departureServiceAction === "DEPARTING";
                    _context3.next = 3;
                    return (0, _effects.select)(function (state) {
                        return state.intl.locale;
                    });

                case 3:
                    locale = _context3.sent;
                    i = 0;

                case 5:
                    if (!(i < segments.length)) {
                        _context3.next = 45;
                        break;
                    }

                    if (!(0, _utilityFunctions.isAllNullish)(segments[i])) {
                        _context3.next = 8;
                        break;
                    }

                    return _context3.abrupt("continue", 42);

                case 8:
                    _context3.next = 10;
                    return (0, _effects.select)(function (state) {
                        return state.user.isZeroScheduleFlow;
                    });

                case 10:
                    isZeroScheduleFlow = _context3.sent;

                    if (!isZeroScheduleFlow) {
                        _context3.next = 13;
                        break;
                    }

                    return _context3.abrupt("continue", 42);

                case 13:
                    _context3.next = 15;
                    return (0, _effects.call)(_apiHelper.postResource, _apiHelper.POST_FLIGHT_SEGMENT_URL, segments[i], authToken);

                case 15:
                    segmentResponse = _context3.sent;

                    if (!(0, _utilityFunctions.hasErrorMessagesInErrorObject)(segmentResponse.error)) {
                        _context3.next = 20;
                        break;
                    }

                    _ret = function () {
                        var requestErrorCode = _lodash2.default.get(segmentResponse.error, "responseLog.status", null);
                        if (requestErrorCode === 400) return {
                                v: segmentResponse
                            };
                        var scheduleErrors = [ZERO_SCHEDULES_RETURNED, SEGMENT_NO_SCHEDULE_MATCH];
                        var hasZeroSchedulesError = segmentResponse.error.errors.some(function (error) {
                            return scheduleErrors.includes(error.code);
                        });
                        return {
                            v: (0, _extends3.default)({}, segmentResponse, {
                                flightSegmentErrorCode: hasZeroSchedulesError ? ZERO_SCHEDULES_RETURNED : DEFAULT_SEGMENT_ERROR_CODE
                            })
                        };
                    }();

                    if (!((typeof _ret === "undefined" ? "undefined" : (0, _typeof3.default)(_ret)) === "object")) {
                        _context3.next = 20;
                        break;
                    }

                    return _context3.abrupt("return", _ret.v);

                case 20:
                    dataForAirportCheck = { authToken: authToken, locale: locale, segmentResponse: segmentResponse };

                    // If segment check succeeds then we check against the transport data.

                    _context3.next = 23;
                    return (0, _effects.select)(function (state) {
                        return state.transferService;
                    });

                case 23:
                    transferServiceData = _context3.sent;

                    if (!(transferServiceData.transfers && transferServiceData.transfers.length)) {
                        _context3.next = 32;
                        break;
                    }

                    _context3.next = 27;
                    return (0, _effects.call)(validateAgainstMultipleTransferServices, isDepartingFromTour, departureServiceId, transferServiceData.transfers, dataForAirportCheck);

                case 27:
                    airportCheck = _context3.sent;

                    if (!airportCheck) {
                        _context3.next = 30;
                        break;
                    }

                    return _context3.abrupt("return", airportCheck);

                case 30:
                    _context3.next = 42;
                    break;

                case 32:
                    _context3.next = 34;
                    return (0, _effects.call)(validateTransferAirport, transferServiceData.arrival, {
                        addressPath: "start_address.airport.iata_code",
                        segmentPath: "arrival_airport.code"
                    }, dataForAirportCheck);

                case 34:
                    arrivalCheckError = _context3.sent;

                    if (!arrivalCheckError) {
                        _context3.next = 37;
                        break;
                    }

                    return _context3.abrupt("return", arrivalCheckError);

                case 37:
                    _context3.next = 39;
                    return (0, _effects.call)(validateTransferAirport, transferServiceData.departure, {
                        addressPath: "finish_address.airport.iata_code", segmentPath: "departure_airport.code"
                    }, dataForAirportCheck);

                case 39:
                    departureCheckError = _context3.sent;

                    if (!departureCheckError) {
                        _context3.next = 42;
                        break;
                    }

                    return _context3.abrupt("return", departureCheckError);

                case 42:
                    i++;
                    _context3.next = 5;
                    break;

                case 45:
                    _context3.next = 47;
                    return _effects.call.apply(undefined, [mainFn].concat(mainArgs));

                case 47:
                    return _context3.abrupt("return", _context3.sent);

                case 48:
                case "end":
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

/**
 * Run a POST flight request after segment checks.
 *
 * @param {Object} toPost Flight data.
 * @param {string} resourceHref API path.
 * @param {string|number} tempId Temp id for the flight.
 * @param {string} authToken Token for API calls.
 * @returns {*} Saga call effect.
 */
var handleToPostFlightStatusRequest = exports.handleToPostFlightStatusRequest = function handleToPostFlightStatusRequest(toPost, resourceHref, tempId, authToken) {
    var departureServiceAction = _lodash2.default.get(toPost, [resourceHref, tempId, "departure_service_action"]);
    var departureServiceId = _lodash2.default.get(toPost, [resourceHref, tempId, "departure_service.id"]);
    var segments = _lodash2.default.get(toPost, [resourceHref, tempId, "segments"], []);
    return (0, _effects.call)(validateSegment, departureServiceAction, departureServiceId, segments, authToken, _apiHelper.postResource, resourceHref, toPost[resourceHref][tempId], // Flight data essentially...
    authToken);
};

/**
 * Run a PATCH flight request after segment checks.
 *
 * @param {string} resourceHref API path.
 * @param {Object} flightData Flight data for patch.
 * @param {string} authToken Token for API calls.
 * @returns {*} Saga call effect.
 */
var handleToPatchFlightStatusRequest = exports.handleToPatchFlightStatusRequest = function handleToPatchFlightStatusRequest(resourceHref, flightData, authToken) {
    return (0, _effects.call)(validateSegment, flightData.departure_service_action, flightData.departure_service.id, flightData.segments, authToken, _updateResources.patchFlight, resourceHref, flightData, authToken);
};


//////////////////
// WEBPACK FOOTER
// ./app/sagas/triggerFlightSegmentValidation.js
// module id = 1423
// module chunks = 0